import React, {Fragment, PureComponent} from 'react';
import I18n from 'app/i18n';
import {getLinkPath} from 'app/utils/link_helper';
import logoFramedSvg from 'images/svg_icons/logo-framed.svg';
import appRuPng from 'images/app/app-ru.png';
import appEnPng from 'images/app/app-en.png';
import androidRuItem1 from 'images/app/android/android-ru-1.png';
import androidRuItem2 from 'images/app/android/android-ru-2.png';
import androidRuItem3 from 'images/app/android/android-ru-3.png';
import androidRuItem4 from 'images/app/android/android-ru-4.png';
import androidEnItem1 from 'images/app/android/android-en-1.png';
import androidEnItem2 from 'images/app/android/android-en-2.png';
import androidEnItem3 from 'images/app/android/android-en-3.png';
import androidEnItem4 from 'images/app/android/android-en-4.png';
import iosRuItem1 from 'images/app/ios/ios-ru-1.png';
import iosRuItem2 from 'images/app/ios/ios-ru-2.png';
import iosRuItem3 from 'images/app/ios/ios-ru-3.png';
import iosEnItem1 from 'images/app/ios/ios-en-1.png';
import iosEnItem2 from 'images/app/ios/ios-en-2.png';
import iosEnItem3 from 'images/app/ios/ios-en-3.png';
import apkImage1 from 'images/app/apk/apk-1.png';
import apkImage2 from 'images/app/apk/apk-2.png';
import apkImage3 from 'images/app/apk/apk-3.png';
import apkImage4 from 'images/app/apk/apk-4.png';
import apkImage5 from 'images/app/apk/apk-5.png';
import apkImage6 from 'images/app/apk/apk-6.png';
import appIosSvg from 'images/svg_icons/app-apple.svg';
import appAndroidSvg from 'images/svg_icons/app-android.svg';
import {Link} from 'react-router-dom';
import {scrollToTop} from 'app/utils';
import logEvent from 'app/amplitude/log_event';
import {modalAlert} from 'app/utils/modals/popups';

const PLATFORM_IMAGES = {
    android: {
        en: [
            androidEnItem1,
            androidEnItem2,
            androidEnItem3,
            androidEnItem4
        ],
        ru: [
            androidRuItem1,
            androidRuItem2,
            androidRuItem3,
            androidRuItem4
        ]
    },
    ios: {
        en: [
            iosEnItem1,
            iosEnItem2,
            iosEnItem3
        ],
        ru: [
            iosRuItem1,
            iosRuItem2,
            iosRuItem3
        ]
    }
};

const APK_IMAGES = [
    apkImage1,
    apkImage2,
    apkImage3,
    apkImage4,
    apkImage5,
    apkImage6
];

const IOS = 'ios';
const ANDROID = 'android';

export default class AppsPage extends PureComponent {
    rootElement = React.createRef();

    deferredPrompt;

    componentDidMount() {
        window.addEventListener('beforeinstallprompt', e => {
            e.preventDefault();
            this.deferredPrompt = e;
        });
    }

    get platform() {
        return this.isAppleDevice() ? IOS : ANDROID;
    }

    handleIosDownload = () => logEvent('MOBILE_APP_DOWNLOADED');

    renderIosWrapperButton() {
        return <a
            href={getLinkPath('/apps/ios/download/')}
            rel="noopener noreferrer"
            target="_blank"
            className="app-info__btn app-info__btn--simple"
            onClick={this.handleIosDownload}
        >
            <img
                src={appIosSvg}
                alt="iOS"
                width="30px"
                height="30px"
            />
            <span>{IOS}</span>
        </a>;
    }

    isIos() {
        return (/iphone|ipad|ipod/u).test(window.navigator.userAgent.toLowerCase());
    }

    isAppleDevice() {
        return (/macintosh|macintel|iphone|ipad|ipod/u).test(window.navigator.userAgent.toLowerCase());
    }

    isInStandaloneMode() {
        return 'standalone' in window.navigator && window.navigator.standalone;
    }

    installApp = () => {
        if (this.isIos() && !this.isInStandaloneMode()) {
            modalAlert(I18n.t('apps_ios_manual'));
        } else if (this.deferredPrompt) {
            this.deferredPrompt.prompt();
            this.deferredPrompt.userChoice.then(() => {
                this.deferredPrompt = null;
            });
        }
    };

    renderAndroidWrapperButton() {
        return <Link
            to={getLinkPath('/apps/android')}
            className="app-info__btn app-info__btn--simple"
            onClick={scrollToTop}
        >
            <img
                src={appAndroidSvg}
                alt="Android"
                width="30px"
                height="30px"
            />
            <span>{ANDROID}</span>
        </Link>;
    }

    renderPlatformItems() {
        const locale = I18n.locale === 'ru' ? 'ru' : 'en';

        return PLATFORM_IMAGES[this.platform][locale].map((imageSrc, index) => <div className="app-info__item" key={this.platform + locale + index}>
            <img src={imageSrc} alt="" className="app-info__item-img"/>
            <div className="app-info__item-num">{index + 1}</div>
            <p className="app-info__item-desc">{I18n.t(`apps_page.${this.platform}_${index + 1}`)}</p>
        </div>);
    }

    render() {
        const PWA = 'pwa';
        const platformClassName = `app-info__platform app-info__platform--${this.platform}`;

        return <Fragment>
            <div ref={this.rootElement} className="app-info">
                <div className="app-info__top">
                    <div className="app-info__top-header app-info-gradient">
                        <Link to={getLinkPath('/')} className="app-info__top-logo">
                            <img src={logoFramedSvg} alt="EGB.com"/>
                        </Link>
                        <div className="app-info__top-title">
                            <p className="app-info__top-title-egb">EGB</p>
                            <p className="app-info__top-text">{I18n.t('mobile_web-app_with_whole_site_functional')}</p>
                        </div>
                    </div>
                    <div className="app-info__top-footer app-info-gradient">
                        <div className="app-info__top-image">
                            <img src={I18n.locale === 'ru' ? appRuPng : appEnPng} alt="" />
                        </div>
                        <div className="app-info__top-install">
                            <p className="app-info__top-text">{I18n.t('apps_page.install_app')}:</p>
                            <div className="app-info__btns">
                                <button
                                    className="app-info__btn"
                                    onClick={this.installApp}
                                >
                                    <img
                                        src={appIosSvg}
                                        alt="iOS"
                                        width="30px"
                                        height="30px"
                                    />
                                    <img
                                        src={appAndroidSvg}
                                        alt="Android"
                                        width="30px"
                                        height="30px"
                                    />
                                    <span>{PWA}</span>
                                </button>
                                {this.isAppleDevice()
                                    ? this.renderIosWrapperButton()
                                    : this.renderAndroidWrapperButton()}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="app-info__content">
                    <p className="app-info__text">{I18n.t('apps_page.choose_a_convenient_option')}</p>
                    <div className="app-info__platform app-info__platform--pwa">
                        <div className="app-info__platform-title">
                            <img
                                src={appIosSvg}
                                alt="iOS"
                                width="30px"
                                height="30px"
                            />
                            <img
                                src={appAndroidSvg}
                                alt="Android"
                                width="30px"
                                height="30px"
                            />
                            <span>{PWA}</span>
                        </div>
                        <p className="app-info__text">{I18n.t('apps_page.pwa')}</p>
                    </div>
                    <p className="app-info__text">{I18n.t('apps_page.if_fails_use_manual_install')}</p>
                    <div className={`app-info__platform ${platformClassName}`}>
                        <div className="app-info__platform-title">
                            {this.isAppleDevice()
                                ? <img
                                    src={appIosSvg}
                                    alt="iOS"
                                    width="30px"
                                    height="30px"/>
                                : <img
                                    src={appAndroidSvg}
                                    alt="Android"
                                    width="30px"
                                    height="30px"/>
                            }
                            <span>{this.platform}</span>
                        </div>
                        <div className="app-info__box">
                            {this.renderPlatformItems()}
                        </div>
                    </div>
                    <p className="app-info__text">{I18n.t('apps_page.installation_less_than_a_minute')}</p>
                    {!this.isAppleDevice() && <div className="app-info__platform">
                        <div className="app-info__platform-title">
                            <img
                                src={appAndroidSvg}
                                alt="Android"
                                width="30px"
                                height="30px"
                            />
                            <span>Android - APK</span>
                        </div>
                        <p className="app-info__text" dangerouslySetInnerHTML={{__html: I18n.t('apps_page.apk')}}/>
                        <div className="app-info__box-apk">
                            {APK_IMAGES.map((imageSrc, index) => <img src={imageSrc} key={`apk-image-${index}`}/>)}
                        </div>
                    </div>}
                </div>
            </div>
        </Fragment>;
    }
}
